module.exports = __webpack_public_path__ + "fonts/zoom-2.svg";